var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1 16.0002C1 24.1003 7.56649 30.6668 15.6667 30.6668C23.7668 30.6668 30.3333 24.1003 30.3333 16.0002C30.3333 7.89999 23.7668 1.3335 15.6667 1.3335C7.56649 1.3335 1 7.89999 1 16.0002Z",
    stroke: "#49A942",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M17.5858 10.3335L12.2929 15.6264C11.9024 16.0169 11.9024 16.6501 12.2929 17.0406L17.5858 22.3335",
    stroke: "#49A942",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginateLeft);
export default __webpack_public_path__ + "static/media/paginateLeft.9a7803ebbaea6a8e358b611ffa0af815.svg";
export { ForwardRef as ReactComponent };